import { RecipeConfig, SlotRecipeConfig } from "shared/theme/sidespor/types";

export const defineSlotRecipe = (recipe: RecipeConfig) =>
  recipe as SlotRecipeConfig;
